export const COLORS = {
	primary: '#F75F2B',
	primaryHover: '#E24009 !important',
	primaryDisable: '#FDDED3',
	primaryRGB: '247, 95, 43',
	secondary: '#8566CC',
	secondaryHover: '#5C39AC !important',
	secondaryRGB: '133, 102, 204',
	separator: '#A28AD8',
	terciary: '#3C3C3C',
	primaryBackgroundBox: '#8566CC',
	inputFocused: '#848484',
	danger: '#DB3900',
	borderPrimary: '#CFCFCF',
	warning: '#AA7200',
	accent: '#A088D7',
	white: '#FFFFFF',
	bg100: '#FAFAFA',
	KidWhite: '#FFFDFA',
	KidPositive: '#D2F8E7',
	KidDanger: '#FFDBCF',
	KidColorSemiPurple: '#DAD1F0 !important',
	kidColorAvatar: '#F98158',
	pending: '#AA7200',
	semiPurple: '#E7E0F5',
	black: '#000000',
	red: '#E62619',
	lightGrey: '#F6F5F4',
	newSemiBlack: '#272522',
	semiBlack: '#363636',
	importantInfo: '#AA7200',
  	infoOK: '#168E58',
};
